module.exports = __webpack_public_path__ + "static/day2-ea3e9d8d50e67204b594f8004129fc2b.mp4";